import { computed, ComputedRef } from "vue"
import store from "@/vue/planning/store/store"
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes"
import availableFlightPackCodes from "@/vue/planning/computed/availableFlightPackCodes"
import { isFlightEnabledLocale } from "@/config/flightPackCode"

const hasTransportOptions: ComputedRef<boolean> = computed(() => {
	const locale = store.getters.locale
	if (isFlightEnabledLocale(locale)) {
		return availableFlightPackCodes.value.length > 0
	}
	return availableTransportPackCodes.value.length > 0
})

export default hasTransportOptions
